import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "channel-onsite",
  "use": "channel-onsite-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"channel-onsite\"><path d=\"M6.333 23.507H17m-15.333-5.12c0 1.413 1.194 2.56 2.666 2.56H19c1.473 0 2.667-1.146 2.667-2.56m-20 0v-8.96c0-1.414 1.194-2.56 2.666-2.56H9m-7.333 11.52h20m0 0v-3.894M15 23.507H8.333L9 20.947h5.333l.667 2.56zm6.533-21.84H14.2a2.667 2.667 0 00-2.667 2.666v4A2.667 2.667 0 0014.2 11h3.333v3.333L20.867 11h.666A2.667 2.667 0 0024.2 8.333v-4a2.667 2.667 0 00-2.667-2.666zm-7 4.333a.333.333 0 100 .667.333.333 0 000-.667zm3.334 0a.333.333 0 100 .667.333.333 0 000-.667zM21.2 6a.333.333 0 100 .667.333.333 0 000-.667z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/channel-onsite.svg
// module id = Fi6D
// module chunks = 39 44